import styled from "styled-components";

import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";

export const StyledPlaybookWizardTitle = styled(Stack)`
    ${integrationMaxWidth};
`;

export const StyledPlaybookWizardLegend = styled(Stack)`
    & > div {
        animation: none;
    }
`;

export const StyledPlaybookWizardContent = styled(Stack)`
    ${integrationMaxWidth};
`;

export const StyledPlaybookWizardFooterContent = styled(Flex)`
    ${integrationMaxWidth};
`;
